const RAW_API_PREFIX = process.env.UMI_APP_API_PREFIX;
const RAW_BASE_URL = process.env.UMI_APP_API_BASE_URL || '';

function normalizePrefix(prefix: string): string {
  const withLeadingSlash = prefix.startsWith('/') ? prefix : `/${prefix}`;
  return withLeadingSlash.replace(/\/+$/, '') || '/';
}

function extractPath(url: string): string {
  try {
    const parsed = new URL(url);
    return parsed.pathname.replace(/\/+$/, '');
  } catch {
    if (!url.startsWith('/')) return '';
    return url.replace(/\/+$/, '');
  }
}

const API_PREFIX = normalizePrefix(RAW_API_PREFIX ?? '');
const BASE_PATH = extractPath(RAW_BASE_URL);
const BASE_ALREADY_HAS_PREFIX =
  API_PREFIX !== '/' &&
  (BASE_PATH === API_PREFIX || BASE_PATH.endsWith(`${API_PREFIX}`));

export function apiPath(path: string): string {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  if (API_PREFIX === '/' || BASE_ALREADY_HAS_PREFIX) return normalizedPath;
  return `${API_PREFIX}${normalizedPath}`;
}
